<template>
  <div>
    <overlay :isActive="showOverlay" @closed="setShowOverlay(false)"></overlay>
    <section class="container-fluid p-0">
      <slot />
    </section>
    <!-- page-footer -->
  </div>
</template>
<script>
import overlay from "./overlay";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    overlay,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["showOverlay"]),
  },
  methods: {
    ...mapMutations(["setShowOverlay"]),
  },
};
</script>
